import { render, staticRenderFns } from "./documentCategories.vue?vue&type=template&id=794d8eef&scoped=true"
import script from "./documentCategories.vue?vue&type=script&lang=js"
export * from "./documentCategories.vue?vue&type=script&lang=js"
import style0 from "./documentCategories.vue?vue&type=style&index=0&id=794d8eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794d8eef",
  null
  
)

export default component.exports